import { useEffect, useState } from "react";
import AccountTransactionPage from "../../../../../entities/DashboardPage/AccountingModule/BankPage/AccountTransactionPage";
import LoaderHelper from "../../../../../utils/Loader/LoaderHelper";
import AuthService from "../../../../../api/AuthService";
import { useLocation } from "react-router-dom";

function AccountTransaction() {
  const [transactionData, setTransactionData] = useState([]);
  const [uncategorizedTransactionData, setUncategorizedTransactionData] =
    useState([]);
  const [customers, setCustomers] = useState([]);
  const [vendors, setVendors] = useState([]);
  const [pageAll, setPageAll] = useState(0);
  const [totalAll, setTotalAll] = useState();
  const [pageUncategorized, setPageUncategorized] = useState(0);
  const [totalUncategorized, setTotalUncategorized] = useState();
  const [accountID, setAccountID] = useState();
  const [bankName, setBankName] = useState();
  const [accountType, setAccountType] = useState();

  const { state } = useLocation();

  useEffect(() => {
    setAccountID(state._id);
    setBankName(state.bankName);
    if(state.bankType === "cash") {
      setAccountType("Cash")
    } else if(state.bankType === "bank") {
      setAccountType("Bank")
    }
  }, []);
  
  useEffect(() => {
    handleGetTransactions("", "", pageAll);
  }, [pageAll]);
  
  useEffect(() => {
    handleGetUncategorizedTransactions("", "", pageUncategorized);
  }, [pageUncategorized]);
  
  useEffect(() => {
    handleGetCustomers();
    handleGetVendors();
  }, []);

  const handleGetTransactions = async (txt, sort, page) => {
    LoaderHelper.loaderStatus(true);

    try {
      const result = await AuthService.handleGetAllAccountTransaction(
        state._id,
        txt,
        sort,
        page,
        "all"
      );
      if (result?.success) {
        setTransactionData(result?.data?.transactions);
        setTotalAll(result?.data?.total);
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const handleGetUncategorizedTransactions = async (txt, sort, page) => {
    LoaderHelper.loaderStatus(true);

    try {
      const result = await AuthService.handleGetAllAccountTransaction(
        state._id,
        txt,
        sort,
        page,
        "Uncategorized"
      );
      if (result?.success) {
        setUncategorizedTransactionData(result?.data?.transactions);
        setTotalUncategorized(result?.data?.total);
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const handleUpdateUncategorizedTransactions = async (id, data) => {
    LoaderHelper.loaderStatus(true);

    try {
      const result = await AuthService.handleUpdteUncategorisedTransaction(
        id,
        data
      );

      //   state._id,
      //   txt,
      //   sort,
      //   page,
      //   "Uncategorized"
      // );
      // if (result?.success) {
      //   setUncategorizedTransactionData(result?.data?.transactions);
      //   setTotalUncategorized(result?.data?.total);
      //   LoaderHelper.loaderStatus(false);
      // } else {
      //   LoaderHelper.loaderStatus(false);
      // }
      LoaderHelper.loaderStatus(false);
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const handleGetCustomers = async () => {
    LoaderHelper.loaderStatus(true);

    try {
      const result = await AuthService.getCustomer();
      if (result?.success) {
        setCustomers(result?.data?.customers);
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const refreshTransactions = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      await handleGetUncategorizedTransactions("", "", pageUncategorized);
      await handleGetTransactions("", "", pageAll);
      LoaderHelper.loaderStatus(false);
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const handleGetVendors = async () => {
    LoaderHelper.loaderStatus(true);

    try {
      const result = await AuthService.getSupplier();
      if (result.success) {
        setVendors(result?.data?.suppliers);
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const handleAddTransaction = async (transaction) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.handleAddAccountTransaction(transaction);
      if (result?.success) {
        // Optionally, refresh the transaction list after adding
        handleGetTransactions();
        LoaderHelper.loaderStatus(false);
        return { success: true, data: result.data };
      } else {
        LoaderHelper.loaderStatus(false);
        return {
          success: false,
          error: result?.message || "Failed to add transaction",
        };
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
      return { success: false, error: error.message || "An error occurred" };
    }
  };

  const handleFilter = (text, sort) => {
    text
      ? handleGetTransactions(text)
      : sort
      ? handleGetTransactions("", sort)
      : null;
  };

  return (
    <AccountTransactionPage
      transactionData={transactionData}
      uncategorizedTransactionData={uncategorizedTransactionData}
      pageAll={pageAll}
      setPageAll={setPageAll}
      totalAll={totalAll}
      pageUncategorized={pageUncategorized}
      setPageUncategorized={setPageUncategorized}
      totalUncategorized={totalUncategorized}
      handleFilter={handleFilter}
      customers={customers}
      vendors={vendors}
      handleAddTransaction={handleAddTransaction}
      accountID={accountID}
      bankName={bankName}
      handleUpdateUncategorizedTransactions={handleUpdateUncategorizedTransactions}
      refreshTransactions={refreshTransactions}
      accountType={accountType}
      showStatementButton={state.bankType === "bank"}
    />
  );
}

export default AccountTransaction;
